import { inquiries } from './inquiries';
import { modals } from './modals';
import { nav } from './nav';


inquiries.init();
modals.init();
nav.init();